// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/headerbg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Static font imports start*/
.toastBox {
  max-width: 40vw;
  width: fit-content;
  font-size: 16px;
  margin-top: 55px;
}
.toastBody {
  width: fit-content;
  font-size: 16px;
}

.toast-success-container {
  /* color: #2d355a !important;
  background: #a6f8c7 !important;
  border: 1px solid #a6cab3 !important; */
  border-radius: 6px !important;
}

.toast-success-container-after {
  overflow: hidden;
  position: relative;
}

.toast-success-container-after {
  overflow: hidden;
  position: relative;
}

.Joyride-tabBox{
  scroll-behavior: smooth;
}

.padding_all {
  padding: 20px 80px;
}

.inputRounded .MuiOutlinedInput-root {
  border-radius: 30px;
  height: 48px;
  padding-right: 6px !important;
}

.inputRounded {
  height: 48px;
  margin-bottom: 2vh;
  border-radius: 30px;
  margin-top: 10px;
  width: 100%;
}

.css-kdqr6q-MuiButtonBase-root-MuiPickersDay-root:not(.Mui-selected){
  border: none !important;
}

/* This folder will contains all the css files and global styles if used */
/* .error_checkbox svg {
  border: 2px solid #d32f2f !important;
} */
hr {
  /* border: 1px solid #eee; */
  margin: 4px 0;
}

.main-content-container {
  min-height: calc(100vh - 55px);
  box-sizing: border-box;
  max-width: 1700px;
  padding-top: 70px;
  margin-left: auto;
  margin-right: auto;
}
.lazy-load-image-background {
  height: 100%;
  width: 100%;
}

.jodit-status-bar-link {
  display: none;
}

.jodit-container {
  border: none !important;
}

.jodit .jodit-workplace .jodit-wysiwyg,
.jodit .jodit-workplace .jodit-wysiwyg_iframe,
.jodit-container .jodit-workplace .jodit-wysiwyg,
.jodit-container .jodit-workplace .jodit-wysiwyg_iframe {
  padding-left: 28px !important;
}

/* .nav-link-user:active{
  color: blue !important;
} */

.loader_content {
  height: calc(100vh - 125px);
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* .active .MuiTypography-root {
  color: #58f2f0;
} */

.active .navIcon {
  display: none;
  /* background: "red"; */
}
.active .navIconHover {
  display: block;
  /* background: "red"; */
}

.bellIcon {
  margin-right: "30px";
  cursor: "pointer";
}
.bellIconHover {
  margin-right: "30px";
  cursor: "pointer";
  display: none;
}

.header-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
}

.MuiDivider-wrapper {
  /* background-color: transparent; */
  width: 100px;
}
/* This is class of modal */
.css-7yntvo-MuiPaper-root-MuiDialog-paper {
  border-radius: 4px;
}

.MuiRadio-root {
  padding: 0px;
}

/* css starts for autocomplete input classes */

.MuiAutocomplete-inputRoot {
  padding: 0 !important;
}

.MuiAutocomplete-input {
  padding: 0.75rem !important;
}

.timeDigit {
  font-size: 20px;
  font-weight: 700;
  /* color: white; */
  margin-left: 5px;
}
.timeDigit1 {
  font-size: 20px;
  font-weight: 700;
  /* color: white; */
}

.timeDigitBlack {
  font-size: 20px;
  font-weight: 700;
  /* color: black; */
  margin-left: 5px;
}

.timeText {
  font-size: 15px;
  font-weight: 700;
  /* color: white; */
  margin-left: 2px;
  margin-right: 5px;
}
.timeTextBlack {
  font-size: 15px;
  font-weight: 700;
  /* color: black; */
  margin-left: 2px;
  margin-right: 5px;
}
.cursor-pointer{
  cursor: pointer;
}

.hideMSReveal::-ms-reveal {
  display: none;
}

.jodit-placeholder{
  font-size: 16px !important;
}

.footer_container .MuiSvgIcon-root{
  font-size: 1.5rem !important;
}

.add-phone .react-tel-input .country-list {
  position: fixed !important;
}

.add-phone .react-tel-input .search {
  position: static !important;
}

/* .css-yiavyu-MuiBackdrop-root-MuiDialog-backdrop{
  background-color: rgb(0 0 0 / 85%);
} */


/* css ends for autocomplete input classes */

@media (max-width: 1200px) {
  .padding_all {
    padding: 20px 60px;
  }
}

@media (max-width: 700px) {
  .toastBox {
    max-width: 80vw;
    width: fit-content;
  }
  .padding_all {
    padding: 20px 40px;
  }
}

@media (max-width: 500px) {
  .main-content-container {
    min-height: 400px;
  }
  .__floater__open {
    max-width: 300px !important;
    margin: 0 auto !important;
    z-index: 5000 !important;
  }
  #react-joyride-step-1 {
    display: flex;
    justify-content: center;
  }
  .main-content-container {
    padding-top: 70px;
  }
  .padding_all {
    padding: 20px 30px;
  }
  .toastBox {
    max-width: 100vw;
    width: 100%;
    right: 0;
  }
  .MuiDialog-paper {
    margin: 15px !important;
  }
}

@media (max-width: 319px) {
  input[type="tel"] {
    margin-left: 20px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;;yCAEuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA,0EAA0E;AAC1E;;GAEG;AACH;EACE,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH;EACE,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yDAAoD;EACpD,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;AACA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,8CAA8C;;AAE9C;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;GAEG;;;AAGH,4CAA4C;;AAE5C;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,2BAA2B;IAC3B,yBAAyB;IACzB,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,QAAQ;EACV;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["/* Static font imports start*/\r\n.toastBox {\r\n  max-width: 40vw;\r\n  width: fit-content;\r\n  font-size: 16px;\r\n  margin-top: 55px;\r\n}\r\n.toastBody {\r\n  width: fit-content;\r\n  font-size: 16px;\r\n}\r\n\r\n.toast-success-container {\r\n  /* color: #2d355a !important;\r\n  background: #a6f8c7 !important;\r\n  border: 1px solid #a6cab3 !important; */\r\n  border-radius: 6px !important;\r\n}\r\n\r\n.toast-success-container-after {\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.toast-success-container-after {\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.Joyride-tabBox{\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n.padding_all {\r\n  padding: 20px 80px;\r\n}\r\n\r\n.inputRounded .MuiOutlinedInput-root {\r\n  border-radius: 30px;\r\n  height: 48px;\r\n  padding-right: 6px !important;\r\n}\r\n\r\n.inputRounded {\r\n  height: 48px;\r\n  margin-bottom: 2vh;\r\n  border-radius: 30px;\r\n  margin-top: 10px;\r\n  width: 100%;\r\n}\r\n\r\n.css-kdqr6q-MuiButtonBase-root-MuiPickersDay-root:not(.Mui-selected){\r\n  border: none !important;\r\n}\r\n\r\n/* This folder will contains all the css files and global styles if used */\r\n/* .error_checkbox svg {\r\n  border: 2px solid #d32f2f !important;\r\n} */\r\nhr {\r\n  /* border: 1px solid #eee; */\r\n  margin: 4px 0;\r\n}\r\n\r\n.main-content-container {\r\n  min-height: calc(100vh - 55px);\r\n  box-sizing: border-box;\r\n  max-width: 1700px;\r\n  padding-top: 70px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n.lazy-load-image-background {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.jodit-status-bar-link {\r\n  display: none;\r\n}\r\n\r\n.jodit-container {\r\n  border: none !important;\r\n}\r\n\r\n.jodit .jodit-workplace .jodit-wysiwyg,\r\n.jodit .jodit-workplace .jodit-wysiwyg_iframe,\r\n.jodit-container .jodit-workplace .jodit-wysiwyg,\r\n.jodit-container .jodit-workplace .jodit-wysiwyg_iframe {\r\n  padding-left: 28px !important;\r\n}\r\n\r\n/* .nav-link-user:active{\r\n  color: blue !important;\r\n} */\r\n\r\n.loader_content {\r\n  height: calc(100vh - 125px);\r\n  width: 100vw;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n/* .active .MuiTypography-root {\r\n  color: #58f2f0;\r\n} */\r\n\r\n.active .navIcon {\r\n  display: none;\r\n  /* background: \"red\"; */\r\n}\r\n.active .navIconHover {\r\n  display: block;\r\n  /* background: \"red\"; */\r\n}\r\n\r\n.bellIcon {\r\n  margin-right: \"30px\";\r\n  cursor: \"pointer\";\r\n}\r\n.bellIconHover {\r\n  margin-right: \"30px\";\r\n  cursor: \"pointer\";\r\n  display: none;\r\n}\r\n\r\n.header-img {\r\n  background-image: url(../assets/images/headerbg.jpg);\r\n  background-size: 100% 100%;\r\n  background-repeat: no-repeat;\r\n  width: 100%;\r\n}\r\n\r\n.MuiDivider-wrapper {\r\n  /* background-color: transparent; */\r\n  width: 100px;\r\n}\r\n/* This is class of modal */\r\n.css-7yntvo-MuiPaper-root-MuiDialog-paper {\r\n  border-radius: 4px;\r\n}\r\n\r\n.MuiRadio-root {\r\n  padding: 0px;\r\n}\r\n\r\n/* css starts for autocomplete input classes */\r\n\r\n.MuiAutocomplete-inputRoot {\r\n  padding: 0 !important;\r\n}\r\n\r\n.MuiAutocomplete-input {\r\n  padding: 0.75rem !important;\r\n}\r\n\r\n.timeDigit {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  /* color: white; */\r\n  margin-left: 5px;\r\n}\r\n.timeDigit1 {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  /* color: white; */\r\n}\r\n\r\n.timeDigitBlack {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  /* color: black; */\r\n  margin-left: 5px;\r\n}\r\n\r\n.timeText {\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  /* color: white; */\r\n  margin-left: 2px;\r\n  margin-right: 5px;\r\n}\r\n.timeTextBlack {\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  /* color: black; */\r\n  margin-left: 2px;\r\n  margin-right: 5px;\r\n}\r\n.cursor-pointer{\r\n  cursor: pointer;\r\n}\r\n\r\n.hideMSReveal::-ms-reveal {\r\n  display: none;\r\n}\r\n\r\n.jodit-placeholder{\r\n  font-size: 16px !important;\r\n}\r\n\r\n.footer_container .MuiSvgIcon-root{\r\n  font-size: 1.5rem !important;\r\n}\r\n\r\n.add-phone .react-tel-input .country-list {\r\n  position: fixed !important;\r\n}\r\n\r\n.add-phone .react-tel-input .search {\r\n  position: static !important;\r\n}\r\n\r\n/* .css-yiavyu-MuiBackdrop-root-MuiDialog-backdrop{\r\n  background-color: rgb(0 0 0 / 85%);\r\n} */\r\n\r\n\r\n/* css ends for autocomplete input classes */\r\n\r\n@media (max-width: 1200px) {\r\n  .padding_all {\r\n    padding: 20px 60px;\r\n  }\r\n}\r\n\r\n@media (max-width: 700px) {\r\n  .toastBox {\r\n    max-width: 80vw;\r\n    width: fit-content;\r\n  }\r\n  .padding_all {\r\n    padding: 20px 40px;\r\n  }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n  .main-content-container {\r\n    min-height: 400px;\r\n  }\r\n  .__floater__open {\r\n    max-width: 300px !important;\r\n    margin: 0 auto !important;\r\n    z-index: 5000 !important;\r\n  }\r\n  #react-joyride-step-1 {\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  .main-content-container {\r\n    padding-top: 70px;\r\n  }\r\n  .padding_all {\r\n    padding: 20px 30px;\r\n  }\r\n  .toastBox {\r\n    max-width: 100vw;\r\n    width: 100%;\r\n    right: 0;\r\n  }\r\n  .MuiDialog-paper {\r\n    margin: 15px !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 319px) {\r\n  input[type=\"tel\"] {\r\n    margin-left: 20px !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
